import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight, UserPlus } from "lucide-react";

// Shown to anonymous visitors once they've used their free run(s).
// Pushes to a FREE account (top of funnel) — not straight to Pro.
export function AnonSignupLock({ testid = "anon-lock", perks = [] }) {
  return (
    <div className="rounded-2xl border-2 border-brand/30 bg-orange-50/60 p-7" data-testid={testid}>
      <div className="w-12 h-12 rounded-xl bg-brand/15 flex items-center justify-center mb-4">
        <UserPlus className="w-6 h-6 text-brand" strokeWidth={2.2} />
      </div>
      <h3 className="font-heading text-xl font-black text-slate-900">Create your free account to keep going</h3>
      <p className="mt-2 text-slate-600 leading-relaxed">
        It's free — no card required. A Community account unlocks unlimited use of every calculator
        plus the full 12-Step Business Foundation Guide.
      </p>
      {perks.length > 0 && (
        <ul className="mt-4 space-y-1.5 text-sm text-slate-600">
          {perks.map((p, i) => (
            <li key={i} className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-brand" /> {p}</li>
          ))}
        </ul>
      )}
      <Link to="/register" data-testid={`${testid}-cta`}>
        <Button className="mt-6 h-13 px-8 py-3 rounded-full bg-brand hover:bg-brand-hover text-white text-base font-bold w-full sm:w-auto group">
          Create my free account
          <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
        </Button>
      </Link>
      <p className="mt-3 text-xs text-slate-500">
        Already a member? <Link to="/login" data-testid={`${testid}-login`} className="text-brand font-bold hover:underline">Log in</Link>
      </p>
    </div>
  );
}

// Soft, non-blocking nudge shown to logged-in Community members alongside results.
export function CommunityProNudge({ testid = "pro-nudge", perk = "unlock the full toolkit" }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={testid}>
      <div className="flex items-center gap-2 mb-1.5">
        <Sparkles className="w-4 h-4 text-brand" />
        <h3 className="font-heading text-base font-bold text-slate-900">You're on the free plan</h3>
      </div>
      <p className="text-sm text-slate-600 leading-relaxed">
        Go Pro to save your results, {perk}, and unlock the AI Coach, Simulated Load Board and unlimited tools.
      </p>
      <Link to="/subscribe" data-testid={`${testid}-cta`}>
        <Button variant="outline" className="mt-4 h-10 px-5 rounded-full border-brand text-brand hover:bg-orange-50 text-sm font-bold w-full sm:w-auto group">
          Go Pro
          <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
        </Button>
      </Link>
    </div>
  );
}
